/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Expired } from '../model';
// @ts-ignore
import type { Match } from '../model';
// @ts-ignore
import type { MissingKeyAlias } from '../model';
// @ts-ignore
import type { PGPKeyDetails } from '../model';
// @ts-ignore
import type { PGPKeyType } from '../model';
// @ts-ignore
import type { PGPSearchField } from '../model';
/**
 * PGPKeyringApi - axios parameter creator
 * @export
 */
export const PGPKeyringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerDeleteKey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPKeyringControllerDeleteKey', 'id', id)
            const localVarPath = `/api/pgp/keyring/deleteKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerDeleteKeys: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('pGPKeyringControllerDeleteKeys', 'requestBody', requestBody)
            const localVarPath = `/api/pgp/keyring/deleteKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPKeyringControllerGetKey', 'id', id)
            const localVarPath = `/api/pgp/keyring/getKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKeyBySha256Fingerprint: async (sha256Fingerprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sha256Fingerprint' is not null or undefined
            assertParamExists('pGPKeyringControllerGetKeyBySha256Fingerprint', 'sha256Fingerprint', sha256Fingerprint)
            const localVarPath = `/api/pgp/keyring/getKeyBySha256Fingerprint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (sha256Fingerprint !== undefined) {
                localVarQueryParameter['sha256Fingerprint'] = sha256Fingerprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKeys: async (expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pgp/keyring/getKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (keyType !== undefined) {
                localVarQueryParameter['keyType'] = keyType;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKeysCount: async (expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pgp/keyring/getKeysCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (keyType !== undefined) {
                localVarQueryParameter['keyType'] = keyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetSubkeys: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pGPKeyringControllerGetSubkeys', 'id', id)
            const localVarPath = `/api/pgp/keyring/getSubkeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchValue 
         * @param {PGPSearchField} [searchField] 
         * @param {Match} [match] 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerSearchKeys: async (searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchValue' is not null or undefined
            assertParamExists('pGPKeyringControllerSearchKeys', 'searchValue', searchValue)
            const localVarPath = `/api/pgp/keyring/searchKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (match !== undefined) {
                localVarQueryParameter['match'] = match;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (keyType !== undefined) {
                localVarQueryParameter['keyType'] = keyType;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchValue 
         * @param {PGPSearchField} [searchField] 
         * @param {Match} [match] 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerSearchKeysCount: async (searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchValue' is not null or undefined
            assertParamExists('pGPKeyringControllerSearchKeysCount', 'searchValue', searchValue)
            const localVarPath = `/api/pgp/keyring/searchKeysCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (match !== undefined) {
                localVarQueryParameter['match'] = match;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (keyType !== undefined) {
                localVarQueryParameter['keyType'] = keyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PGPKeyringApi - functional programming interface
 * @export
 */
export const PGPKeyringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PGPKeyringApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerDeleteKey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerDeleteKey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerDeleteKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerDeleteKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerDeleteKeys(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerDeleteKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerGetKey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPKeyDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerGetKey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerGetKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerGetKeyBySha256Fingerprint(sha256Fingerprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGPKeyDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerGetKeyBySha256Fingerprint(sha256Fingerprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerGetKeyBySha256Fingerprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerGetKeys(expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerGetKeys(expired, missingKeyAlias, keyType, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerGetKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerGetKeysCount(expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerGetKeysCount(expired, missingKeyAlias, keyType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerGetKeysCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerGetSubkeys(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerGetSubkeys(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerGetSubkeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchValue 
         * @param {PGPSearchField} [searchField] 
         * @param {Match} [match] 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerSearchKeys(searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PGPKeyDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerSearchKeys(searchValue, searchField, match, expired, missingKeyAlias, keyType, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerSearchKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchValue 
         * @param {PGPSearchField} [searchField] 
         * @param {Match} [match] 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pGPKeyringControllerSearchKeysCount(searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pGPKeyringControllerSearchKeysCount(searchValue, searchField, match, expired, missingKeyAlias, keyType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PGPKeyringApi.pGPKeyringControllerSearchKeysCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PGPKeyringApi - factory interface
 * @export
 */
export const PGPKeyringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PGPKeyringApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerDeleteKey(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pGPKeyringControllerDeleteKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerDeleteKeys(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.pGPKeyringControllerDeleteKeys(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKey(id: string, options?: any): AxiosPromise<PGPKeyDetails> {
            return localVarFp.pGPKeyringControllerGetKey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sha256Fingerprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKeyBySha256Fingerprint(sha256Fingerprint: string, options?: any): AxiosPromise<PGPKeyDetails> {
            return localVarFp.pGPKeyringControllerGetKeyBySha256Fingerprint(sha256Fingerprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKeys(expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<PGPKeyDetails>> {
            return localVarFp.pGPKeyringControllerGetKeys(expired, missingKeyAlias, keyType, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetKeysCount(expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options?: any): AxiosPromise<number> {
            return localVarFp.pGPKeyringControllerGetKeysCount(expired, missingKeyAlias, keyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerGetSubkeys(id: string, options?: any): AxiosPromise<Array<PGPKeyDetails>> {
            return localVarFp.pGPKeyringControllerGetSubkeys(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchValue 
         * @param {PGPSearchField} [searchField] 
         * @param {Match} [match] 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerSearchKeys(searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<PGPKeyDetails>> {
            return localVarFp.pGPKeyringControllerSearchKeys(searchValue, searchField, match, expired, missingKeyAlias, keyType, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchValue 
         * @param {PGPSearchField} [searchField] 
         * @param {Match} [match] 
         * @param {Expired} [expired] 
         * @param {MissingKeyAlias} [missingKeyAlias] 
         * @param {PGPKeyType} [keyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pGPKeyringControllerSearchKeysCount(searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options?: any): AxiosPromise<number> {
            return localVarFp.pGPKeyringControllerSearchKeysCount(searchValue, searchField, match, expired, missingKeyAlias, keyType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PGPKeyringApi - object-oriented interface
 * @export
 * @class PGPKeyringApi
 * @extends {BaseAPI}
 */
export class PGPKeyringApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerDeleteKey(id: string, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerDeleteKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerDeleteKeys(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerDeleteKeys(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerGetKey(id: string, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerGetKey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sha256Fingerprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerGetKeyBySha256Fingerprint(sha256Fingerprint: string, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerGetKeyBySha256Fingerprint(sha256Fingerprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Expired} [expired] 
     * @param {MissingKeyAlias} [missingKeyAlias] 
     * @param {PGPKeyType} [keyType] 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerGetKeys(expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerGetKeys(expired, missingKeyAlias, keyType, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Expired} [expired] 
     * @param {MissingKeyAlias} [missingKeyAlias] 
     * @param {PGPKeyType} [keyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerGetKeysCount(expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerGetKeysCount(expired, missingKeyAlias, keyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerGetSubkeys(id: string, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerGetSubkeys(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchValue 
     * @param {PGPSearchField} [searchField] 
     * @param {Match} [match] 
     * @param {Expired} [expired] 
     * @param {MissingKeyAlias} [missingKeyAlias] 
     * @param {PGPKeyType} [keyType] 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerSearchKeys(searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerSearchKeys(searchValue, searchField, match, expired, missingKeyAlias, keyType, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchValue 
     * @param {PGPSearchField} [searchField] 
     * @param {Match} [match] 
     * @param {Expired} [expired] 
     * @param {MissingKeyAlias} [missingKeyAlias] 
     * @param {PGPKeyType} [keyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PGPKeyringApi
     */
    public pGPKeyringControllerSearchKeysCount(searchValue: string, searchField?: PGPSearchField, match?: Match, expired?: Expired, missingKeyAlias?: MissingKeyAlias, keyType?: PGPKeyType, options?: RawAxiosRequestConfig) {
        return PGPKeyringApiFp(this.configuration).pGPKeyringControllerSearchKeysCount(searchValue, searchField, match, expired, missingKeyAlias, keyType, options).then((request) => request(this.axios, this.basePath));
    }
}

